import { useEffect } from 'react';
import { useUser } from '@contexts/UserContext';
import { useAppDispatch, useAppSelector } from '@store';
import { fetchModels, clearModels } from '@store/slices/modelsSlice';

export const ModelsInitializer = () => {
  const { user } = useUser();
  const dispatch = useAppDispatch();
  const isLoadingModels = useAppSelector((state) => state.models.isLoading);
  const hasFetched = useAppSelector((state) => state.models.hasFetched);

  useEffect(() => {
    const username = user?.username;

    // Clear models when user logs out
    if (!username) {
      dispatch(clearModels());
      return;
    }

    // Fetch models when user is available and we haven't fetched yet
    if (!hasFetched && !isLoadingModels) {
      dispatch(fetchModels(username));
    }
  }, [user?.username, hasFetched, isLoadingModels, dispatch]);

  return null;
};
